<template>
  <span class="enterprise-svg-icon" :style="iconStyle" aria-hidden="true" />
</template>

<script setup lang="ts">
const props = defineProps<{
  src: string
}>()

const iconStyle = computed(() => ({
  '--enterprise-icon-url': `url("${props.src}")`,
}))
</script>

<style scoped>
.enterprise-svg-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  flex: 0 0 auto;
  color: inherit;
  background: currentColor;
  mask: var(--enterprise-icon-url) center / contain no-repeat;
  -webkit-mask: var(--enterprise-icon-url) center / contain no-repeat;
}
</style>
